<template>
    <div>
        <ButtonSelectField
            :options="loanTerms"
            :selected="selected"
            :name="name"
            :customErrorMessage="$t(`results.resubmit.fields.loanTerm.errorMessage`)"
            :validationRules="validationRules"
            buttonClasses="wizard-button"
        />
    </div>
</template>

<script>
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { loanTerms } from '@js/utilities/loanDetails.js'

export default {
    // static settings to initialize step (not reactive inside this file!)
    stepDefinition() {
        return {
            name: 'loanTerm',
            hideContinue: true,
            route: {
                relativeUrl: `term`,
                name: 'apply.loanTerm',
                meta: {
                    title: 'form.sections.loanDetails.term',
                    layoutType: 'large',
                },
            },
            fields: {
                loanTerm: {
                    value: null,
                    mappedKey: 'loan_term',
                    formatterOnSummary: 'monthsToYears',
                    formatterOnQuery: 'numericFormatter',
                    validationRules: {
                        required: true,
                    },
                },
            },
        }
    },

    data() {
        return {
            name: 'loanTerm',
        }
    },
    setup() {
        const router = useRouter()
        const route = useRoute()
        const store = useStore()

        return {
            router,
            route,
            store,
        }
    },
    mounted() {
        this.emitter.emit('stepLoaded')

        this.store.dispatch('updateStepSetting', {
            setting: 'hideContinue',
            settingValue: !Boolean(this.loanTerm),
            step: this.store.state.apply.currentRouteStep,
        })
    },
    computed: {
        value: function () {
            return this.store.getters.fieldValue(this.name)
        },
        loanTerms,
        validationRules: function () {
            return this.store.getters.fieldValidationRules(this.name)
        },
    },
    methods: {
        selected: function (values) {
            this.emitter.emit('nextStep')
        },
    },
}
</script>
